import {request, requestUpload} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let CustomerController = {
    getListCustomer: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    createCustomer: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    editCustomer: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detailCustomer: (customerId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer/detail/${customerId}`,
            method: 'GET',
        }, callback)
    },
    deleteCustomer: (customerId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer/delete/${customerId}`,
            method: 'GET',
        }, callback)
    },
    searchCustomer: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detailCustomerGroup: (idGroup, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/detail/${idGroup}`,
            method: 'GET',
        }, callback)
    },
    editCustomerGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    deleteCustomerGroup: (idGroup, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/delete/${idGroup}`,
            method: 'GET',
        }, callback)
    },
    importCustomer: (payload, callback) => {
        const data = new FormData()
        payload.file.map(item => {
            data.append('file', item)
        })
        return requestUpload({
            url: `${URL_API}/api/sas-qlts/customer/import?yearId=${payload.yearId}`,
            method: 'POST',
            body: data,
        }, callback);
    },
}

export default CustomerController
